import React from 'react';
import PropTypes from 'prop-types';

import { getDeletedCommentString, getEditedCommentString } from '../helpers';
import { constructCn } from '../../../../utilities/helperFunctions';

import './ModerationLabel.scss';

const ModerationLabel = ({ type, date, className }) => {
    const text =
        type === 'edit'
            ? getEditedCommentString(date)
            : getDeletedCommentString(date);

    const cn = constructCn(
        'component-Community-CommentBox-ModerationLabel',
        className
    );

    return <div className={cn}>{text}</div>;
};

ModerationLabel.propTypes = {
    date: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['edit', 'delete']).isRequired,
    className: PropTypes.string,
};

ModerationLabel.defaultProps = {
    className: '',
};

ModerationLabel.displayName = 'ModerationLabel';

export default ModerationLabel;
